import React from 'react'
import Link from 'gatsby-link'
import SiteBranding from './SiteBranding'

const NavBar = ({ siteTitle }) => (
  <nav className="navbar is-transparent" role="navigation" aria-label="main navigation">
  <div className="navbar-brand">
    <SiteBranding />

    <a role="button" className="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample" onClick={() => { let toggle = document.querySelector(".navbar-burger"); let menu = document.querySelector(".navbar-menu"); toggle.classList.toggle("is-active"); menu.classList.toggle("is-active"); }}>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navbarBasicExample" className="navbar-menu">

      <div className="navbar-item has-dropdown is-hoverable">
        <a className="navbar-item" href="/">
          Galleries
        </a>

        <div className="navbar-dropdown">
        <a className="navbar-item" href="/#gallery-1">
          Garden Gnomes
        </a>
        <a className="navbar-item" href="/#gallery-2">
          At One With Nature
        </a>
        </div>
      </div>

      <Link className="navbar-item" to="/about">
        About
      </Link>

      <Link className="navbar-item" to="/contact">
        Contact
      </Link>

    </div>
</nav>
)

export default NavBar


// WEBPACK FOOTER //
// ./src/components/NavBar.js